module.exports = __webpack_public_path__ + "a3b8a67b79e9a2d9abfa3b49da2fda63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/a/a06.jpg
// module id = 490
// module chunks = 0